var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsViewList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.917h15a.833.833 0 1 1 0 1.666h-15a.833.833 0 1 1 0-1.666zm0 4.166h15a.833.833 0 0 1 0 1.667h-15a.833.833 0 1 1 0-1.667zm0 4.167h15a.833.833 0 1 1 0 1.667h-15a.833.833 0 0 1 0-1.667zm0 4.167h15a.833.833 0 1 1 0 1.666h-15a.833.833 0 1 1 0-1.666z",
    fill: "#1B3DF2",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsViewList);
export default __webpack_public_path__ + "static/media/icons-view-list.fab8f477b2361e295874ed11af10c9b4.svg";
export { ForwardRef as ReactComponent };